import { array, string, size, tuple } from 'superstruct';
export const CartAttributeName = size(string(), 1, 256);
export const CartAttribute = tuple([
    CartAttributeName,
    string()
]);
export const Payload = array(CartAttribute);
export const makeUpdateCartAttributes = function(agent) {
    return async function updateCartAttributes(rawPayload) {
        const attrEntries = Payload.create(rawPayload);
        const attributes = attrEntries.reduce(function(acc, [key, value]) {
            acc[key] = value;
            return acc;
        }, {});
        await agent.post('/cart/update.js', {
            json: {
                attributes
            }
        }).json();
    };
};
